export const COMING = 'coming' // 尚未開始
export const ONGOING = 'ongoing' // 進行中
export const EXPIRED = 'expired' // 已結束
export const INTERRUPTED = 'interrupted' // 已失效(人為手動結束)
